// utils/api/sessionService.ts
import config from '../../config';
import { apiHandler } from './responseHandler';
import { passwordAPI } from './passwordAPI';

/**
 * Session service for lightweight operations and password management
 * Now uses secure passwordAPI for all password-related operations
 */
export const sessionService = {
    /**
     * Sends a lightweight ping to "wake up" the database
     * @returns Promise that resolves when the ping completes
     */
    pingServer: async (): Promise<boolean> => {
        try {
            const response = await apiHandler.fetch(
                `${config.API_URL}/api/session-ping`,
                {
                    method: 'GET',
                    timeout: 5000 // 5 second timeout
                }
            );
            return response.status === 200;
        } catch (error) {
            console.warn('Server ping failed:', error);
            return false;
        }
    },

    /**
     * Authenticates a user with username and password
     * @param userName The username
     * @param password The plaintext password
     * @returns User info if successful
     */
    login: async (userName: string, password: string) => {
        return await passwordAPI.login(userName, password);
    },

    /**
     * Sets a password for a user account
     * @param userId The user ID
     * @param password The plaintext password
     * @returns True if successful
     */
    setPassword: async (userId: number, password: string): Promise<boolean> => {
        return await passwordAPI.setPassword(userId, password);
    }
};